import React from 'react';
// import { motion } from 'framer-motion';
// import { Link } from 'react-router-dom';
// import SafeIcon from '../common/SafeIcon';
// import * as FiIcons from 'react-icons/fi';

// const { FiArrowRight, FiCode, FiUsers, FiTrendingUp } = FiIcons;

const HomePage = () => {
  return (
    <div className="min-h-screen bg-black-900 text-white flex flex-col items-center justify-center p-4">
      <h1 className="text-4xl font-bold mb-4 font-serif">Page Temporarily Disabled</h1>
      <p className="text-lg text-black-300">This page is currently unavailable.</p>
    </div>
  );
  /*
  const fadeInUp = { hidden: { opacity: 0, y: 30 }, visible: { opacity: 1, y: 0 } };

  return (
    <div className="min-h-screen bg-white pt-16">
      
      <section className="pt-20 pb-16 bg-gradient-to-br from-black-900 to-black-800 text-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial="hidden"
            animate="visible"
            variants={{ visible: { transition: { staggerChildren: 0.2 } } }}
            className="text-center"
          >
            <motion.h1
              variants={fadeInUp}
              className="text-4xl md:text-7xl font-bold mb-8 leading-tight font-serif"
            >
              Learn to Build Real Apps<br />
              <span className="text-blue-400">With AI in Marathi</span>
            </motion.h1>
            <motion.p
              variants={fadeInUp}
              className="text-xl text-black-200 mb-10 leading-relaxed max-w-3xl mx-auto"
            >
              Practical, hands-on courses designed to help you build real-world projects and grow your career.
            </motion.p>
            <motion.div
              variants={fadeInUp}
              className="flex flex-col sm:flex-row gap-4 justify-center items-center"
            >
              <Link to="/courses">
                <motion.button
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  className="px-8 py-4 bg-red-600 text-white rounded-lg font-bold text-xl hover:bg-red-700 transition-colors shadow-xl flex items-center gap-2"
                >
                  <span>Explore Courses</span>
                  <SafeIcon icon={FiArrowRight} className="w-6 h-6" />
                </motion.button>
              </Link>
            </motion.div>
          </motion.div>
        </div>
      </section>

      
      <section className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-100px" }}
            variants={fadeInUp}
            className="text-center mb-12"
          >
            <h2 className="text-3xl md:text-5xl font-bold text-black-900 mb-6 font-serif">
              Why Learn With Us?
            </h2>
            <div className="w-24 h-1 bg-black-900 mx-auto mt-6 mb-8"></div>
          </motion.div>

          <div className="grid md:grid-cols-3 gap-8">
            {[
              {
                icon: FiCode,
                title: "Practical Projects",
                description: "Build real-world applications and gain hands-on experience."
              },
              {
                icon: FiUsers,
                title: "Expert Guidance",
                description: "Learn from industry experts with real-world experience."
              },
              {
                icon: FiTrendingUp,
                title: "Career Growth",
                description: "Acquire skills that are in high demand in the tech industry."
              }
            ].map((feature, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="bg-black-50 p-8 rounded-xl shadow-lg border border-black-200 text-center"
              >
                <div className="w-16 h-16 bg-black-900 rounded-full flex items-center justify-center mx-auto mb-6">
                  <SafeIcon icon={feature.icon} className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-2xl font-bold text-black-900 mb-4">{feature.title}</h3>
                <p className="text-lg text-black-700">{feature.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 bg-black-900 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <h2 className="text-3xl font-bold mb-6">
              Ready to Start Your Learning Journey?
            </h2>
            <p className="text-xl text-black-200 mb-8 max-w-2xl mx-auto">
              Choose a course that aligns with your career goals and start building today.
            </p>
            <Link to="/courses">
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="px-8 py-4 bg-white text-black-900 rounded-lg font-semibold text-lg hover:bg-black-100 transition-colors shadow-lg flex items-center gap-2 mx-auto"
              >
                <span>View All Courses</span>
                <SafeIcon icon={FiArrowRight} className="w-5 h-5" />
              </motion.button>
            </Link>
          </motion.div>
        </div>
      </section>
    </div>
  );
  */
};

export default HomePage;